/* Import Modules */
import axios, { AxiosRequestConfig } from "axios";
import toastr from "toastr";

/* Import Variables */
import { userEditForm } from "../../variables";

/* Define Function */
const getAxiosOptions = () => {
  const axiosOptions: AxiosRequestConfig = {
    xsrfHeaderName: "X-XSRF-TOKEN",
    withCredentials: true,
    url: `/api/schedule_user/${userEditForm.id}`,
    method: "PATCH",
    data: {
      schedule_id: userEditForm.id,
      schedule_users: userEditForm.users,
    },
  };

  return axiosOptions;
};

export const updateScheduleUser = async () => {
  const axiosOptions = await getAxiosOptions();
  axios(axiosOptions)
    .then((result) => {
      // 自画面リロード
      window.location.reload();
    })
    .catch((error) => {
      toastr.error("登録に失敗しました");
      console.log(error);
    });
};
